export function encrypt (content) {
  if (content) {
    content = content.trim()
    if (content) {
      return content
        .split('')
        .reverse()
        .join('')
    }
    return ''
  }
  return ''
}

export function triggerWindowResizeEvent () {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

export function formatLocation (location) {
  if (!location || typeof location !== 'string') {
    return location
  }
  const parts = location.split('|').filter(
    part => part !== '' && part !== '0',
  )
  return parts.length ? parts.join('|') : ''
}

export function replaceNullToString (obj) {
  const tempObj = Object.assign({}, obj)
  for (const item in tempObj) {
    if (tempObj[item] === null || tempObj[item] === undefined) {
      tempObj[item] = ''
    }
  }
  return tempObj
}
